import * as actions from '../actions/actionTypes';

const initialState = {
  rank: [],
  employeeLocations: [],
  delay: [],
  spenthours: [],
  absences: [],
  delayedes: [],
};

const fetchExtraHoursRankSuccess = (state, action) => ({ ...state, rank: action.rank });

const fetchEmployeeLocationsSuccess = (state, action) => ({
  ...state,
  employeeLocations: action.employeeLocations,
});

const fetchDelaySuccess = (state, action) => ({ ...state, delay: action.delay });

const fetchHoursSuccess = (state, action) => ({ ...state, spenthours: action.spenthours });

const fetchAbsencesSuccess = (state, action) => ({ ...state, absences: action.absences });

const fetchDelayedesSuccess = (state, action) => ({...state, delayedes: action.delayedes });

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_EXTRA_HOURS_RANK_SUCCESS:
      return fetchExtraHoursRankSuccess(state, action);
    case actions.FETCH_EMPLOYEE_LOCATIONS_SUCCESS:
      return fetchEmployeeLocationsSuccess(state, action);
    case actions.FETCH_DELAY_SUCCESS:
      return fetchDelaySuccess(state, action);
    case actions.FETCH_HOURS_SUCCESS:
      return fetchHoursSuccess(state, action);
    case actions.FETCH_ABSENCES_SUCCESS:
      return fetchAbsencesSuccess(state, action);
    case action.FETCH_DELAYEDES_SUCCESS:
      return fetchDelayedesSuccess(state, action);
    default:
      return state;
  }
};

export default reducer;
